import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { gdprGuard } from './guards/gdpr/gdpr.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./tabs/tabs.module').then((m) => m.TabsPageModule),
    canActivate: [gdprGuard]
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'profilo',
    loadChildren: () =>
      import('./pages/profilo/profilo.module').then((m) => m.ProfiloPageModule),
  },
  {
    path: 'impostazioni',
    loadChildren: () =>
      import('./pages/impostazioni/impostazioni.module').then(
        (m) => m.ImpostazioniPageModule
      ),
  },
  {
    path: 'registrazione',
    loadChildren: () =>
      import('./pages/my-pet/registrazione/registrazione.module').then(
        (m) => m.RegistrazionePageModule
      ),
  },
  {
    path: 'update',
    loadChildren: () =>
      import('./pages/update/update.module').then((m) => m.UpdatePageModule),
  },
  {
    path: 'pet-diet',
    loadChildren: () =>
      import('./pages/pet-diet/pet-diet.module').then(
        (m) => m.PetDietPageModule
      ),
  },
  {
    path: 'consensi-aggiornati',
    loadChildren: () => import('./pages/consensi-aggiornati/consensi-aggiornati.module').then( m => m.ConsensiAggiornatiPageModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('./pages/chat/chat.module').then( m => m.ChatPageModule)
  },
  {
    // Fallback: un deep link verso un path inesistente non deve lasciare l'utente
    // su una schermata vuota. '' carica il modulo tabs, che redirige a /tabs/home.
    path: '**',
    redirectTo: '',
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
